export default __webpack_public_path__ + "static/media/ParentRoleIcon.829ea4e7.svg";